import { OnboardingDocument } from "./onboarding.model";
import { OPERATION } from "./supplier.model";

/** Tax ID Type (e.g., EIN, SSN) */
export interface TaxIDType {
    taxIDTypeID: number,
    name: string,
    description: string,
    enabled: boolean,
    countryID: number
}

/** Tax country */
export interface TaxCountryConfig {
    country: string,
    regionGroup: string,
    abbreviation: string,
    regexPattern: string,
    validationMessage: string,
    blockList: string[]
}

export class WithHoldingQuestionResponse
{
  QuestionIdentifier: string;
  QuestionResponse: any;
}
export class WithHoldingResponse
{
  CountryCode: string;
  WithHoldingQuestionResponse: WithHoldingQuestionResponse[];
}

/** Tax Information of the supplier. */
export class SupplierTaxInfo {
    ID: number;
    StageID: number;
    Operation: OPERATION;
    Tax1099Box: string;
    Report1099: boolean;
    W9Received: boolean;
    W8Received: boolean;
    WithHoldingSelection: string[];
    TaxIDTypes: string;
    TaxName: string
    Corporate: boolean;
    FederalTaxID: string;
    Last4FederalTaxID: string;
    VATNumber: string;
    TaxCountry: string;
    DoYouHaveVat: string;
    IsNewRecord: boolean;
    FederalTaxIDExists: boolean;
    Classification: string;
    ClassificationType: string;
    OtherCompany: string;
    Documents: string[];
    DocumentInfos: OnboardingDocument[];
    FileFederalTax?: boolean;
    EntityType: string;
    WithHoldingResponse?: WithHoldingResponse[];
    RequiredDocuments?: OnboardingDocument[];
    IsModified?: boolean;
    CompanyType?: string;
    IsOptional?: boolean;
    AdditionalTaxIds: AdditionalTaxInfoValue[];
}

export class WithHoldingTaxInfoResponse {
  countryList : string[];
  isSupplierOnboarding : boolean;
  existingEntityList: string[];
  additionalWithHoldingInfo: AdditionalWithHoldingInfo[];
  withHoldingQuestionSchema: any;
  additionalFormDataInfo: AdditionalFormData[];
  onChangeEventFunctionInfo: string[];
  formDataFieldConfigurationKeyMap: string[];
}

export class AdditionalFormData {
  key : string;
  valueInfo : FormDataValueInfo;
  valuePath: string;
  isTranslationNeeded: boolean;
  processResponse: boolean;
}

export class FormDataValueInfo {
  type : string;
  value : string;
  additionalInfo: FormDataAdditionalValueInfo[];
}

export enum FormDataDataType {
  STRING = "string"
}

export class FormDataAdditionalValueInfo {
  key : string;
  value : string;
}

export class AdditionalWithHoldingInfo
{
  country: string;
  isWithHoldingQuestionSkipped: boolean;
}
export class SupplierConfigurationPropertiesResponse {

  taxIdTypes: TaxIdTypeInfo[];
  additionalTaxIdTypes: TaxIdTypeInfo[];
  documentTypes: DocumentTypeProps[];
  taxIdAdditionalTypeVerbiage: string;
  optionalDocumentList: DocumentTypeProps[];
}

export enum TaxIdentifierType {
  TaxType = 'taxIdTypes',
  AdditionalTaxType = 'additionalTaxIdTypes'
}

export class TaxIdTypeInfo {
  taxIdType: string;
  description: string;
  isMandatory: boolean;
  isSecure: boolean;
  taxIdTypeValidationInfo : TaxIdTypeValidationConfig;
  taxIdTypeValue: string;
}

export class AdditionalTaxInfoValue {
  taxIdType: string;
  isSecure: boolean;
  taxIdValue: string;
  isEncrypted: boolean;
  last4TaxIdValue: string;
  constructor() {
    this.isSecure = false;
    this.isEncrypted = false;
  }
}

export enum FieldPermission {
  Read = 'read',
  ReadWrite = 'readwrite'
}

export class DocumentTypeProps {
  documentTypeID: number;
  name: string;
  description: string;
  category: string;
  enabled: boolean;
  isDocumentAvailableForSupplier: boolean;
  associatedCategoryLinkId: string[];
  isOptional: boolean;
}

export class SupplierConfigurationPropertiesPayload
{
  SupplierCode: string;
  Entity: string;
  Category:string;
  Country: string;
  AdditionalFilter: QuestionFieldConfig[];
}

export enum SupplierConfigurationCategoryEnum
{
  // Regular Onboarding
  TAX = 'Tax',
  ADDRESS = 'Address'
}

export class QuestionFieldConfig
{
  FieldName: string;
  Response: string;
}

export class TaxIdTypeValidationConfig
{
  taxIdType: string;
  isRequired: boolean;
  isBlockedListValidationRequired : boolean;
  blockListValidationPattern : string[];
  regexFormatPattern: string;
  minLength : number;
  maxLength : number;
  errorMessage : TaxIdTypeValidationErrorMessage;
}

export class TaxIdTypeValidationErrorMessage
{
  patternError: string;
  minLengthError : string;
  maxLengthError : string;
  blockedListError : string;
}